import * as yup from "yup";

const schema = yup.object().shape({
  name: yup
    .string()
    .required("This field is required")
    .min(3, "Gateway name should be between 3 and 25 characters.")
    .max(25, "Gateway name should be between 3 and 25 characters.")
    .matches(/^[0-9a-z\-]+$/, "Only a-z, numbers, and '-' allowed"),

  brand: yup.string().required("This field is required"),
  proxyServer: yup.string().required("This field is required"),

  subscriberDetails: yup.object().shape({
    firstName: yup.string().required("This field is required"),
    lastName: yup.string().required("This field is required"),
    email: yup
      .string()
      .required("This field is required")
      .email("Invalid email format"),
    brandId: yup.string().required("This field is required"),
  }),
});

export default schema;
